import manufacturingActions from './manufacturingActions'

const initState = {
    fetchManufacturingDevicesData: [],
    fetchAllManufacturingDevicesData: [],
    loading: false,
    loadingAllDevices: false,
    createManufacturingDevicesData: [],
    editView: false,
};


export default function ManufacturingReducer (state = initState, payload) {
    switch (payload.type) {
        case manufacturingActions.CREATE_MANUFACTURING_DEVICES:
            return {...state, loading: true}
        case manufacturingActions.CREATE_MANUFACTURING_DEVICES_SUCCESS:
            return {
                ...state,
                createManufacturingDevicesData: payload.devices, loading: false}
        case manufacturingActions.CREATE_MANUFACTURING_DEVICES_ERROR:
            return {
                ...state,
                loading: false
            }
        case manufacturingActions.FETCH_MANUFACTURING_DEVICES:
            return {
                ...state,
                loading: true,
                editView: false,
            }
        case manufacturingActions.FETCH_MANUFACTURING_DEVICES_SUCCESS:
            return {
                ...state,
                fetchManufacturingDevicesData: payload.devices,
                loading:false
            }
        case manufacturingActions.FETCH_ALL_MANUFACTURING_DEVICES:
            return {
                ...state,
                loadingAllDevices: true,
            }
        case manufacturingActions.FETCH_ALL_MANUFACTURING_DEVICES_SUCCESS:
            return {
                ...state,
                fetchAllManufacturingDevicesData: payload.devices,
                loadingAllDevices: false,
            }
        case manufacturingActions.EDIT_MANUFACTURING_DEVICE:
            return {
                ...state,
                editManufacturingDevice: payload.device,
                loading:true
            }
        case manufacturingActions.EDIT_MANUFACTURING_DEVICE_SUCCESS:
            return {...state, loading:false}
        default: return state
    }
}
